export default __webpack_public_path__ + "static/media/element_9.c61ad677.webp";